import React from "react";

export default function SmallCreditWidgets({
  icon,
  count,
  title,
  onClick,
  className,
}) {
  return (
    <div
      className={`rounded-2 bg-white d-flex common-shadow ${className} credit-small-winget`}
      onClick={onClick}
    >
     
      <div>
        {count && <h5 className=" fw-medium ">{count}</h5>}
        {title && <p className="text-capitalize pt-1">{title}</p>}
      </div>
      {icon && (
        <div className="icon rounded-1 d-flex align-items-center justify-content-center">
          {icon}
        </div>
      )}
    </div>
  );
}
